import { render, staticRenderFns } from "./DashStats.vue?vue&type=template&id=0a69caa5&scoped=true&"
import script from "./DashStats.vue?vue&type=script&lang=ts&"
export * from "./DashStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a69caa5",
  null
  
)

export default component.exports